import React from 'react';

/** The <th> every sortable column previously hand-wrote (cursor/userSelect style, the
 * up/down/neutral icon swap) - kept as a plain function rather than a hook since it's just
 * markup, so it composes directly into a <tr> the same way a raw <th> would. Paired with
 * hooks/useSortableData.ts. */
export function SortableTh<F extends string | number>({
  field,
  active,
  dir,
  onSort,
  width,
  children,
}: {
  field: F;
  active: boolean;
  dir: 'asc' | 'desc';
  onSort: (field: F) => void;
  width?: string | number;
  children: React.ReactNode;
}) {
  return (
    <th style={{ width, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }} onClick={() => onSort(field)}>
      {children}{' '}
      <i
        className={
          !active
            ? 'ri-expand-up-down-line ms-1 text-muted opacity-50'
            : dir === 'asc' ? 'ri-sort-asc ms-1 text-primary' : 'ri-sort-desc ms-1 text-primary'
        }
        style={{ fontSize: '0.75rem' }}
      ></i>
    </th>
  );
}
